import { render, staticRenderFns } from "./ComprasDiretasDisponiveisTabela.vue?vue&type=template&id=9e3362e8&scoped=true"
import script from "./ComprasDiretasDisponiveisTabela.vue?vue&type=script&lang=js"
export * from "./ComprasDiretasDisponiveisTabela.vue?vue&type=script&lang=js"
import style0 from "./ComprasDiretasDisponiveisTabela.vue?vue&type=style&index=0&id=9e3362e8&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e3362e8",
  null
  
)

export default component.exports